import { Text } from '@diamond/shared/ui';
import {
  type NlbMovementType,
  mapMovementToDisplay,
} from '@diamond/sol-buyer/utils';

export interface NlbAmountCellProps {
  movementType: NlbMovementType;
  amount: number;
}

export function NlbAmountCell({ movementType, amount }: NlbAmountCellProps) {
  const display = mapMovementToDisplay(movementType, amount);

  return (
    <Text
      fontSize="sm"
      fontWeight="medium"
      color={display.colorScheme === 'blue' ? 'blue' : 'red'}
    >
      {display.formattedAmount}
    </Text>
  );
}
